export default "__VITE_ASSET__CWKCHwsk__"